<template>
	<div v-if="!isLoading && !isGetError" class="flex flex-col">
		<div class="container mb-16">
			<UAlert
				v-if="sponsors.length === 0"
				description="Infos zu den Unterstützern kommen bald. Bitte seid gespannt!"
				icon="i-heroicons-information-circle"
				variant="subtle"
				color="warning"
				class="mt-8"
			/>
		</div>

		<div
			v-if="sponsors.length > 0"
			class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:gap-12"
		>
			<SponsorsOneSponsor
				v-for="(sponsor, index) in sponsors"
				:key="sponsor.id"
				:sponsor="sponsor"
				:index="index"
				class="mb-6"
			/>
		</div>
	</div>
	<UAlert
		v-else
		type="error"
		title="Hoppla!"
		icon="i-heroicons-exclamation-circle"
		description="Beim Laden der Unterstützer ist ein Fehler aufgetreten. Bitte versuche es nochmal."
		color="error"
		variant="soft"
	/>
</template>

<script lang="ts" setup>
const isGetError = ref(false)

const isLoading = ref(true)
const sponsorsStore = useAllSponsorsStore()
const { allSponsors: sponsors } = storeToRefs(sponsorsStore)
await sponsorsStore.getAllSponsors()
isLoading.value = false

// function accentColorWave(index: number) {
// 	const relativeIndex = index % 4
// 	switch (relativeIndex) {
// 		case 0:
// 			return 'darkestGreen'
// 		case 1:
// 			return 'brightGreen'
// 		case 2:
// 			return 'brightRed'
// 		case 3:
// 			return 'brightestGreen'
// 		default:
// 			return 'darkestRed'
// 	}
// }
</script>

<style></style>
